import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function requireCredentialsRule(
  rule: components["schemas"]["RequireCredentialsRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      credentials: components["schemas"]["CredentialsCheckField"]["value"]
    ) => {
      if (rule.highest) {
        return credentials.some(({ highest_level }) => highest_level === true);
      }
      return credentials.length >= rule.min;
    },
  };
}
